export default __webpack_public_path__ + "static/media/outsourcing-icon4.f2350fe4.svg";